import * as pdfjsLib from 'pdfjs-dist';

// Doğru PDF.js worker kaynağını ayarla
const setupPDFWorker = (): void => {
  try {
    // CDN üzerinden PDF.js worker'ı
    const cdnWorkerUrl = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;
    
    // Önce CDN yolunu dene
    pdfjsLib.GlobalWorkerOptions.workerSrc = cdnWorkerUrl;
    
    console.log('PDF.js worker loaded from CDN:', cdnWorkerUrl);
  } catch (error) {
    console.error('Error setting up PDF worker:', error);
  }
};

export default setupPDFWorker;
